var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10","xl":"6"}},[_c('RewardsSummary',{attrs:{"customer":_vm.customer}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }